import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, VertCarousel } from '@vertem-core/vertice-ds'
const CarouselBannersService = ({ banners }) => {
  const [init, setInit] = useState(false);
  const [width, setWidthState] = useState(0);

  if (!banners.length) return <div />;
  const setWidth = () => {
    const { innerWidth } = window.top;
    if (innerWidth > 1426) {
      return 1416;
    } if (innerWidth > 1226) {
      return 1216;
    } if (innerWidth > 1018) {
      return 992 + 16;
    } if (innerWidth > (768 + 26)) {
      return 768 + 16;
    } if (innerWidth > (576 + 26)) {
      return 576 + 16;
    }

    return 254;
  };

  const formatArray = useCallback(() => {
    const response = [];
    let count = 0;
    let temp = [];
    banners.forEach(({ image, link }) => {
      const { innerWidth } = window.top;
      if (innerWidth > (576 + 26)) {
        if (count < 3) {
          temp.push({
            image,
            link,
          });
        } else {
          count = 0;
          response.push(temp);
          temp = [];
          temp.push({
            image,
            link,
          });
        }
        count += 1;
      } else {
        response.push([{
          image,
          link,
        }]);
      }
    });

    if (temp.length) {
      response.push(temp);
    }

    return response;
  }, [banners]);

  useEffect(() => {
    if (!init) {
      setInit(true);
      window.top.addEventListener('resize', () => {
        setWidthState(setWidth());
      }, false);
    }
  }, [init]);

  return (
    <Row>
      <VertCarousel
        dots={false}
        arrows
        itemsPerPage={1}
        variableWidth
        centerPadding="16px"
        centerMode={window.top.innerWidth > (576 + 26)}
      >
        {
        formatArray().map((list) => (
          <div
            style={{
              width: `${width || setWidth()}px`,
            }}
            className="CarouselBannersService box"
            key={JSON.stringify(list)}
          >
            <section
              className="CarouselBannersService row"
            >
              {
                list.map(({ image }) => (
                  <div
                    className="CarouselBannersService item"
                    key={image}
                  >
                    <figure>
                      <img src={image} alt="" />
                    </figure>
                  </div>
                ))
              }
            </section>
          </div>
        ))
      }
      </VertCarousel>
    </Row>
  );
};


CarouselBannersService.propTypes = {
  banners: PropTypes.array,
};

export default CarouselBannersService;
